<template>
  <div id="djs-content-container" class="content_container">
    <docendo-connnection-indicator></docendo-connnection-indicator>
    <router-view name="SideNav" class="d-sidenav-active"></router-view>
    <div id="app" class="page-width d-page-width">
      <router-view name="Header"></router-view>
      <router-view name="Navigation"></router-view>
      <router-view></router-view>
    </div>
    <Toast></Toast>
  </div>
</template>

<script>
  import SideNav from './components/SideNav'
  import Toast from './components/toast/Manager.vue'
  import DocendoConnnectionIndicator from './components/DocendoConnectionIndicator'
  import Manifest from './appmanifest.json' // eslint-disable-line no-unused-vars

  export default {
    components: {
      DocendoConnnectionIndicator, SideNav, Toast
    }
  }
</script>

<style>
  @import './assets/css/base.css';
  @import './assets/css/simplegrid.css';
  @import './assets/css/utilites.css';
  @import './assets/css/common.css';
  @import './assets/css/flex.css';
  @import './assets/css/animate.css';
  @import './assets/css/docendo-animate.css';
  @import './assets/css/vue-transitions.css';
  @import './assets/css/hint.css';
  @import './assets/fonts/style.css';

  .d-sidenav-active + .d-page-width {
    margin-left: 65px;
    transition: margin-left 0.25s;
  }

  .djs_menu_out .d-sidenav-active + .d-page-width {
    margin-left: 265px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?22e82a58